import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { rolesApi as r } from "@maat/api-main";
//#region src/workspaces/useCreateRoleMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.createRole(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.roles() });
		}
	});
};
//#endregion
export { i as useCreateRoleMutation };
